import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  main: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '50px 40px 0',
      color: "gray"
    },
  socials: {
    textDecoration: 'none',
    color: "gray",
  }

}));
